import * as actionsType from "appRedux/actions/license/licenseActionType"

export type LicenseState = {
    license_info: {
        active: boolean;
        expire_date?: string | null;
        is_expire: boolean;
        warning?: boolean;
        warning_message?: string | null;
        warning_title?: string | null;
        renew_link_url?: string | null;
        renew_link_text?: string | null;
    }
    loading: boolean;
    error: any;
}

const INIT_STATE: LicenseState = {
    license_info: {
        active: true,
        expire_date: null,
        is_expire: false,
        warning: false,
        warning_message: null,
        warning_title: null,
        renew_link_url: null,
        renew_link_text: null,
    },
    loading: false,
    error: null
};

const licenseReducer = (state = INIT_STATE, action: actionsType.LicenseAction): LicenseState => {
    switch (action.type) {
        case actionsType.LICENSE_REQUEST:
            return { ...state, loading: true, error: null };
        case actionsType.LICENSE_REQUEST_SUCCESS:
            return { ...state, license_info:{...action.payload}, loading: false, error: null };
        case actionsType.LICENSE_REQUEST_FAILED:
            return { ...state, loading: false, error: action.payload };
        case actionsType.LICENSE_PROCESS_RESET:
            return INIT_STATE;
        default:
            return state;
    }
};

export default licenseReducer;
